const ITEMS = [
  "RAPID DEPLOYMENT MAINTENANCE",
  "TACTICAL REPAIR PROTOCOLS",
  "25 SPECIALIZED OPERATIONS",
  "LICENSED & INSURED CREWS",
  "MISSION: FIX IT RIGHT",
];

export const Marquee = () => (
  <div className="relative overflow-hidden bg-olive border-y border-olive-deep py-3" data-testid="tactical-marquee">
    <div className="marquee-track flex whitespace-nowrap w-max">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex" aria-hidden={dup === 1}>
          {ITEMS.map((item) => (
            <span key={`${dup}-${item}`} className="mx-6 text-xs tracking-[0.3em] text-obsidian font-bold">
              /// {item}
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
